import { isUndefined } from 'lodash';
import { createAction } from '@mews/framework';

const EMPTY_TYPE = 'EMPTY_ACTION_DISPATCHED';
const FETCH_ACTION_BASE_META = { isFetchAction: true };
const BACKGROUND_ACTION_BASE_META = { isFetchAction: true, isBackgroundAction: true };

export function createErrorAction<P, M>(type: string, error: Error, payload?: P, meta?: M) {
    if (!isUndefined(payload)) {
        if (!isUndefined(meta)) {
            return { type, error, payload, meta };
        }

        return { type, error, payload };
    }

    return { type, error };
}

export function createFetchAction<P, M>(type: string, payload: P, meta?: M) {
    return createAction(type, payload, { ...meta, ...FETCH_ACTION_BASE_META });
}

export function createBackgroundAction<P, M>(type: string, payload: P, meta?: M) {
    return createAction(type, payload, { ...meta, ...BACKGROUND_ACTION_BASE_META });
}

export function createEmptyAction() {
    return createAction(EMPTY_TYPE);
}
